import { DEFAULT_LANGUAGE, TYPE_KEY } from "../common/constant";
import rest from "../common/rest";
import { getOptionListFromResult } from "../utils/OptionsUtils";
import { CHANGE_LANGUAGE_ACTION, LANGUAGE } from "./languageSelector";
import { createBackendErrorMessages, createErrorMessages, messagesReceived } from "./message";

export const REDUCER = "LECTORATE_TYPE/";
export const LECTORATE_TYPE_LIST_LOAD_SUCCESS = REDUCER + "LECTORATE_TYPE_LIST_LOAD_SUCCESS";

// state props
export const LECTORATE_TYPE_LIST = "lectorateTypeList";
export const LECTORATE_TYPE_OPTIONS = "lectorateTypeOptions";

const initialState = {
  [LECTORATE_TYPE_LIST]: [],
  [LECTORATE_TYPE_OPTIONS]: [],
  [LANGUAGE]: DEFAULT_LANGUAGE,
};

export default function reducer(state = initialState, action) {
  let newState;
  switch (action[TYPE_KEY]) {
    case LECTORATE_TYPE_LIST_LOAD_SUCCESS:
      newState = {
        ...state,
        [LECTORATE_TYPE_LIST]: action[LECTORATE_TYPE_LIST],
        [LECTORATE_TYPE_OPTIONS]: getOptionListFromResult(state[LANGUAGE], action[LECTORATE_TYPE_LIST])
      };
      break;

    case CHANGE_LANGUAGE_ACTION:
      newState = {
        ...state,
        [LANGUAGE]: action[LANGUAGE],
        [LECTORATE_TYPE_OPTIONS]: getOptionListFromResult(action[LANGUAGE], state[LECTORATE_TYPE_LIST])
      };
      break;

    default:
      newState = { ...state };
      break;
  }

  return newState;
}

export function loadLectorateTypes() {
  return (dispatch) => {
    rest.doGet(`/admin/admin/predefined/lectorate_type`).then(
      (result) => {
        if (result) {
          dispatch({ [TYPE_KEY]: LECTORATE_TYPE_LIST_LOAD_SUCCESS, [LECTORATE_TYPE_LIST]: result });
        } else {
          dispatch(messagesReceived(createErrorMessages(result)));
        }
      },
      (reason) => {
        dispatch(messagesReceived(createBackendErrorMessages(reason)));
      }
    );
  };
}